// import React, { useEffect, useState } from "react";
// import { api } from "@/api/client";
// import { Section, Button, Input, Select, Badge, Empty } from "@/components/ui/kit";
// import { toast } from "sonner";
// import { Plus, Filter, ExternalLink, ArrowLeft, Search, DownloadCloud } from "lucide-react";

// export default function BeneficiariesList() {
//   // Main Table State
//   const [rows, setRows] = useState([]);
//   const [type, setType] = useState("");
//   const [search, setSearch] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [hasSearched, setHasSearched] = useState(false);
  
//   // Dynamic Filters State
//   const [dynamicSchema, setDynamicSchema] = useState([]);
//   const [filterValues, setFilterValues] = useState({});
//   const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  
//   // Dependent Blocks State for Cascading Dropdown
//   const [dynamicBlocks, setDynamicBlocks] = useState([]);
//   const [isLoadingBlocks, setIsLoadingBlocks] = useState(false);

//   // Student Detail View State
//   const [selectedStudentId, setSelectedStudentId] = useState(null);
//   const [studentDetails, setStudentDetails] = useState(null);
//   const [isLoadingDetails, setIsLoadingDetails] = useState(false);

//   // Add / Import Beneficiary State
//   const [openAdd, setOpenAdd] = useState(false);
//   const [nb, setNb] = useState({ type: "STUDENT", name: "", address: "", description: "" });
  
//   // Student Import Specific State
//   const [pendingImports, setPendingImports] = useState([]);
//   const [selectedImportIds, setSelectedImportIds] = useState([]);
//   const [isImporting, setIsImporting] = useState(false);
//   const [importSearch, setImportSearch] = useState(""); // <-- NEW: Search state for imports

//   // ==========================================================================
//   // 1. DATA FETCHING (Search & Filters)
//   // ==========================================================================
//   const handleApplyFilters = () => {
//     if (!type) {
//       toast.error("Please select a beneficiary type first");
//       return;
//     }

//     setIsLoading(true);
//     setHasSearched(true);

//     const params = { 
//       size: 100, 
//       type: type, 
//       search: search || undefined,
//       ...filterValues 
//     };

//     api.get("/beneficiaries", { params })
//        .then(r => setRows(r.data.data.content))
//        .catch(() => toast.error("Failed to fetch records"))
//        .finally(() => setIsLoading(false));
//   };

//   useEffect(() => {
//     setRows([]);
//     setHasSearched(false);
//     setDynamicBlocks([]);
    
//     if (type === "STUDENT") {
//       setIsLoadingFilters(true);
//       api.get("/beneficiaries/filters-schema", { params: { type: "STUDENT" } })
//         .then(r => {
//           const schemaWithoutBlock = (r.data.data.filters || []).filter(f => f.field !== "block");
//           setDynamicSchema(schemaWithoutBlock);
//           setFilterValues({});
//         })
//         .catch(() => {
//           setDynamicSchema([]);
//           setFilterValues({});
//         })
//         .finally(() => setIsLoadingFilters(false));
//     } else {
//       setDynamicSchema([]);
//       setFilterValues({});
//     }
//   }, [type]);

//   const handleDynamicFilterChange = (field, value) => {
//     setFilterValues(prev => ({ ...prev, [field]: value }));

//     if (field === "district") {
//       setFilterValues(prev => ({ ...prev, block: "" }));
//       setDynamicBlocks([]);

//       if (value) {
//         setIsLoadingBlocks(true);
//         api.get("/beneficiaries/blocks", { params: { district: value } })
//           .then(r => setDynamicBlocks(r.data.data || []))
//           .catch(() => {
//             toast.error("Failed to load blocks for this district");
//             setDynamicBlocks([]);
//           })
//           .finally(() => setIsLoadingBlocks(false));
//       }
//     }
//   };

//   const handleTypeChange = (e) => {
//     setType(e.target.value);
//     setSelectedStudentId(null);
//   };

//   // ==========================================================================
//   // 2. STUDENT DETAIL VIEW
//   // ==========================================================================
//   const handleStudentClick = (studentId) => {
//     setSelectedStudentId(studentId);
//     setIsLoadingDetails(true);
//     api.get(`/beneficiaries/student-details/${studentId}`)
//       .then(r => setStudentDetails(r.data.data))
//       .catch(() => toast.error("Failed to load student details"))
//       .finally(() => setIsLoadingDetails(false));
//   };

//   // ==========================================================================
//   // 3. ADD / IMPORT LOGIC
//   // ==========================================================================
  
//   useEffect(() => {
//     if (openAdd && nb.type === "STUDENT") {
//       api.get("/beneficiaries/pending-imports")
//          .then(r => {
//            setPendingImports(r.data.data || []);
//            setSelectedImportIds([]);
//            setImportSearch(""); // Reset search on open
//          })
//          .catch(() => toast.error("Failed to load pending students for import"));
//     }
//   }, [openAdd, nb.type]);

//   // Derived state: Filter the pending imports based on the search bar
//   const filteredPendingImports = pendingImports.filter(s => 
//     (s.studentName || "").toLowerCase().includes(importSearch.toLowerCase()) || 
//     (s.enrId || "").toString().includes(importSearch)
//   );

//   // Check if all currently visible (filtered) items are selected
//   const isAllSelected = filteredPendingImports.length > 0 && 
//                         filteredPendingImports.every(s => selectedImportIds.includes(s.studentId));

//   const handleSelectAllImports = (e) => {
//     if (e.target.checked) {
//       // Add all currently filtered IDs to the selection
//       const filteredIds = filteredPendingImports.map(s => s.studentId);
//       const newSelection = Array.from(new Set([...selectedImportIds, ...filteredIds]));
//       setSelectedImportIds(newSelection);
//     } else {
//       // Remove all currently filtered IDs from the selection
//       const filteredIds = filteredPendingImports.map(s => s.studentId);
//       const newSelection = selectedImportIds.filter(id => !filteredIds.includes(id));
//       setSelectedImportIds(newSelection);
//     }
//   };

//   const handleImportStudents = async () => {
//     if (selectedImportIds.length === 0) return toast.error("Select at least one student");
    
//     setIsImporting(true);
//     try {
//       await api.post("/beneficiaries/import", { studentIds: selectedImportIds });
//       toast.success("Students successfully imported into DRMS!");
//       setOpenAdd(false);
//       setSelectedImportIds([]);
//       if (type === "STUDENT") handleApplyFilters(); 
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Import failed");
//     } finally {
//       setIsImporting(false);
//     }
//   };

//   const handleSaveManual = async (e) => {
//     e.preventDefault();
//     try {
//       await api.post("/beneficiaries", nb);
//       toast.success("Beneficiary manually added");
//       setOpenAdd(false); 
//       setNb({ type: "SCHOOL", name: "", address: "", description: "" });
//       handleApplyFilters();
//     } catch (err) { 
//       toast.error(err.response?.data?.message || "Failed to add beneficiary"); 
//     }
//   };

//   // ==========================================================================
//   // RENDER: STUDENT DETAIL VIEW
//   // ==========================================================================
//   if (selectedStudentId) {
//     return (
//       <div className="space-y-6">
//         <div className="flex items-center gap-4">
//           <Button variant="secondary" onClick={() => setSelectedStudentId(null)}>
//             <ArrowLeft className="w-4 h-4 mr-2" /> Back to List
//           </Button>
//           <h2 className="text-xl font-display font-bold text-emerald-950">Student Full Profile</h2>
//         </div>

//         {isLoadingDetails ? (
//           <div className="p-8 text-center text-muted-foreground">Loading student profile...</div>
//         ) : studentDetails ? (
//           <div className="rounded-xl border border-emerald-900/10 bg-white p-6 space-y-6 shadow-sm">
            
//             <div className="border-b pb-4">
//               <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Personal Information</span>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Student Name</span>
//                   <span className="text-lg font-semibold text-emerald-950">{studentDetails.studentName}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Enrollment ID (Code)</span>
//                   <span className="mono font-semibold">{studentDetails.enrId}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Gender</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.gender || "—"}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Date of Birth</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.dob}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Contact Number</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.contactNumber}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Aadhaar Number</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.aadhaarNumber}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="border-b pb-4">
//               <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Family & Background</span>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Father's Name</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.fatherName}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Mother's Name</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.motherName}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Disability Status</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.disabilityStatus}</span>
//                 </div>
//                 <div className="sm:col-span-2 lg:col-span-3">
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Home Address</span>
//                   <span className="text-sm text-emerald-950">{studentDetails.homeAddress || "—"}</span>
//                 </div>
//               </div>
//             </div>

//             <div>
//               <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Academic Details</span>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-3">
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Cohort</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.cohortName || "—"}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Batch</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.batchName || "—"}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">Medium</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.medium || "—"}</span>
//                 </div>
//                 <div>
//                   <span className="text-xs text-muted-foreground uppercase tracking-wider block">School Name</span>
//                   <span className="font-medium text-emerald-900">{studentDetails.schoolName}</span>
//                 </div>
//               </div>
//             </div>

//           </div>
//         ) : (
//           <Empty title="Student details not found" />
//         )}
//       </div>
//     );
//   }

//   // ==========================================================================
//   // RENDER: MAIN LIST VIEW
//   // ==========================================================================
//   return (
//     <div className="space-y-6">
//       <Section title="Beneficiaries" kicker="People we serve"
//         right={<Button onClick={() => setOpenAdd(v => !v)} data-testid="add-beneficiary-btn"><Plus className="w-4 h-4" /> Add beneficiary</Button>} />

//       {/* --- ADD / IMPORT COMPONENT --- */}
//       {openAdd && (
//         <div className="rounded-xl border border-emerald-900/20 bg-emerald-50/30 p-6 mb-6 shadow-sm">
//           <div className="mb-4">
//             <h3 className="text-lg font-semibold text-emerald-950">Register Beneficiary in DRMS</h3>
//             <p className="text-sm text-muted-foreground">Import active students from the portal or manually register schools/communities.</p>
//           </div>

//           <div className="mb-6 max-w-xs">
//             <Select label="Beneficiary Category" value={nb.type} onChange={e => setNb({...nb, type: e.target.value})}>
//               <option value="STUDENT">Student (Sync from Portal)</option>
//               <option value="SCHOOL">School (Manual Entry)</option>
//               <option value="COMMUNITY">Community (Manual Entry)</option>
//             </Select>
//           </div>

//           {nb.type === "STUDENT" ? (
//             <div className="space-y-4 max-w-2xl">
              
//               {/* SEARCH BAR FOR PENDING STUDENTS */}
//               <Input 
//                 placeholder="Search pending students by name or ID..." 
//                 value={importSearch} 
//                 onChange={e => setImportSearch(e.target.value)}
//               />

//               <div className="border border-emerald-900/10 rounded-lg bg-white overflow-hidden flex flex-col">
                
//                 {/* SELECT ALL HEADER */}
//                 <div className="bg-emerald-50/60 border-b border-emerald-900/10 p-3 flex items-center gap-3">
//                   <input 
//                     type="checkbox" 
//                     checked={isAllSelected}
//                     onChange={handleSelectAllImports}
//                     disabled={filteredPendingImports.length === 0}
//                     className="w-4 h-4 text-emerald-600 rounded border-gray-300 focus:ring-emerald-500 cursor-pointer"
//                   />
//                   <span className="text-sm font-semibold text-emerald-950">
//                     Select All ({filteredPendingImports.length} visible)
//                   </span>
//                 </div>

//                 {/* SCROLLABLE STUDENT LIST */}
//                 <div className="max-h-64 overflow-y-auto p-2">
//                   {filteredPendingImports.length === 0 ? (
//                     <div className="p-6 text-center text-sm text-muted-foreground">
//                       {importSearch ? "No students match your search." : "No new active students available to import."}
//                     </div>
//                   ) : (
//                     filteredPendingImports.map(s => (
//                       <label key={s.studentId} className="flex items-center gap-3 p-2 hover:bg-emerald-50 rounded cursor-pointer transition-colors border-b border-emerald-50 last:border-0">
//                         <input 
//                           type="checkbox" 
//                           className="w-4 h-4 text-emerald-600 rounded border-gray-300 focus:ring-emerald-500"
//                           checked={selectedImportIds.includes(s.studentId)}
//                           onChange={(e) => {
//                             if(e.target.checked) setSelectedImportIds([...selectedImportIds, s.studentId]);
//                             else setSelectedImportIds(selectedImportIds.filter(id => id !== s.studentId));
//                           }} 
//                         />
//                         <div className="flex-1 text-sm font-medium text-emerald-950">{s.studentName}</div>
//                         <div className="text-xs text-muted-foreground font-mono w-24 text-right">{s.enrId}</div>
//                         <div className="text-xs text-emerald-700 w-24 text-right">{s.cohortName}</div>
//                       </label>
//                     ))
//                   )}
//                 </div>
//               </div>

//               <Button onClick={handleImportStudents} disabled={selectedImportIds.length === 0 || isImporting}>
//                 <DownloadCloud className="w-4 h-4 mr-2" />
//                 {isImporting ? "Importing..." : `Import ${selectedImportIds.length} Selected Students`}
//               </Button>
//             </div>
//           ) : (
//             <form onSubmit={handleSaveManual} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <Input label="Name" required value={nb.name} onChange={e => setNb(v => ({...v, name: e.target.value}))} />
//               <Input label="Address / Location" value={nb.address} onChange={e => setNb(v => ({...v, address: e.target.value}))} />
//               <div className="sm:col-span-2">
//                 <Input label="Description / Details" value={nb.description} onChange={e => setNb(v => ({...v, description: e.target.value}))} />
//               </div>
//               <div className="sm:col-span-2 pt-2">
//                 <Button type="submit">Save Manual Entry</Button>
//               </div>
//             </form>
//           )}
//         </div>
//       )}

//       {/* --- LIST & FILTERS --- */}
//       <div className="rounded-xl border border-emerald-900/10 bg-white p-4 space-y-4">
//         {/* Type & General Search Bar */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//           <Select testid="ben-type-filter" value={type} onChange={handleTypeChange}>
//             <option value="">Select Type to view…</option>
//             <option value="STUDENT">Students</option>
//             <option value="SCHOOL">Schools</option>
//             <option value="COMMUNITY">Communities</option>
//           </Select>
//           <Input testid="ben-search" placeholder="Search by name…" value={search} onChange={e => setSearch(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && handleApplyFilters()} />
//         </div>

//         {/* Dynamic Filters Section with Cascading Blocks */}
//         {dynamicSchema.length > 0 && (
//           <div className="p-4 bg-emerald-50/50 border border-emerald-100 rounded-lg space-y-4">
//             <div className="flex items-center gap-2 text-sm font-semibold text-emerald-900">
//               <Filter className="w-4 h-4" /> {isLoadingFilters ? "Loading Filters..." : "Filter Hierarchy (Optional Selection)"}
//             </div>
            
//             {!isLoadingFilters && (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
//                 {dynamicSchema.map(filter => {
//                   if (filter.inputType === "select") {
//                     return (
//                       <Select 
//                         key={filter.field} 
//                         value={filterValues[filter.field] || ""} 
//                         onChange={(e) => handleDynamicFilterChange(filter.field, e.target.value)}
//                       >
//                         <option value="">All {filter.label}s</option>
//                         {filter.options?.map(opt => (
//                           <option key={opt.value} value={opt.value}>{opt.label}</option>
//                         ))}
//                       </Select>
//                     );
//                   }
//                   return (
//                     <Input 
//                       key={filter.field} 
//                       placeholder={filter.label} 
//                       type={filter.inputType || "text"}
//                       value={filterValues[filter.field] || ""} 
//                       onChange={(e) => handleDynamicFilterChange(filter.field, e.target.value)} 
//                     />
//                   );
//                 })}

//                 {/* Dependent Block Dropdown */}
//                 <Select 
//                   value={filterValues["block"] || ""} 
//                   onChange={(e) => handleDynamicFilterChange("block", e.target.value)}
//                   disabled={!filterValues["district"] || isLoadingBlocks}
//                 >
//                   <option value="">{isLoadingBlocks ? "Loading blocks..." : "All Blocks"}</option>
//                   {dynamicBlocks.map(block => (
//                     <option key={block.value} value={block.value}>{block.label}</option>
//                   ))}
//                 </Select>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Explicit Apply Filters Action Button */}
//         {type && (
//           <div className="flex justify-end pt-2">
//             <Button onClick={handleApplyFilters} data-testid="apply-filters-btn" className="flex items-center gap-2">
//               <Search className="w-4 h-4" /> {isLoading ? "Applying Filters..." : "Apply Filters & Fetch Data"}
//             </Button>
//           </div>
//         )}

//         {/* Results Grid with Student Name Hyperlink */}
//         <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" style={{ opacity: isLoading ? 0.5 : 1 }}>
//           {rows.map(b => (
//             <div key={b.beneficiaryId} data-testid={`beneficiary-card-${b.beneficiaryId}`} className="rounded-xl border border-emerald-900/10 bg-[#F7F4EF]/60 p-4 flex flex-col">
//               <div className="flex items-center justify-between">
//                 <div className="mono text-xs text-emerald-900">{b.code || b.enr_id}</div>
//                 <Badge tone={b.type === "STUDENT" ? "brand" : b.type === "SCHOOL" ? "indigo" : "warm"}>{b.type}</Badge>
//               </div>
              
//               {/* HYPERLINK ON STUDENT NAME */}
//               <div className="mt-2">
//                 {b.type === "STUDENT" ? (
//                   <button 
//                     onClick={() => handleStudentClick(b.beneficiaryId)} 
//                     className="font-display font-semibold text-emerald-950 hover:underline text-left flex items-center gap-1 group"
//                   >
//                     {b.name} <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
//                   </button>
//                 ) : (
//                   <div className="font-display font-semibold text-emerald-950">{b.name}</div>
//                 )}
//               </div>

//               <div className="text-xs text-muted-foreground line-clamp-1">{b.address || "—"}</div>
//               <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{b.description}</div>
              
//               {b.medium && <div className="mt-auto pt-2 text-[10px] uppercase tracking-wider text-emerald-700/70 font-semibold">Medium: {b.medium}</div>}
//             </div>
//           ))}

//           {!rows.length && !isLoading && hasSearched && (
//             <div className="col-span-full">
//               <Empty title="No beneficiaries match the selected filters" testid="beneficiaries-empty" />
//             </div>
//           )}

//           {!rows.length && !isLoading && !hasSearched && type && (
//             <div className="col-span-full py-8 text-center text-muted-foreground text-sm">
//               Please select your filters above and click <strong>Apply Filters & Fetch Data</strong> to view results.
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Section, Button, Input, Select, Badge, Empty } from "@/components/ui/kit";
import { toast } from "sonner";
import { Plus, Filter, ExternalLink, ArrowLeft, Search, DownloadCloud } from "lucide-react";

export default function BeneficiariesList() {
  // Main Table State
  const [rows, setRows] = useState([]);
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  
  // Dynamic Filters State
  const [dynamicSchema, setDynamicSchema] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  
  // Dependent Blocks State for Cascading Dropdown
  const [dynamicBlocks, setDynamicBlocks] = useState([]);
  const [isLoadingBlocks, setIsLoadingBlocks] = useState(false);

  // Student Detail View State
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [studentDetails, setStudentDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  // Add / Import Beneficiary State
  const [openAdd, setOpenAdd] = useState(false);
  const [nb, setNb] = useState({ type: "STUDENT", name: "", address: "", description: "" });
  
  // Student Import Specific State
  const [pendingImports, setPendingImports] = useState([]);
  const [selectedImportIds, setSelectedImportIds] = useState([]);
  const [isImporting, setIsImporting] = useState(false);
  const [importSearch, setImportSearch] = useState(""); // <-- NEW: Search state for imports

  // ==========================================================================
  // 1. DATA FETCHING (Search & Filters)
  // ==========================================================================
  const handleApplyFilters = () => {
    if (!type) {
      toast.error("Please select a beneficiary type first");
      return;
    }

    setIsLoading(true);
    setHasSearched(true);

    const params = { 
      size: 100, 
      type: type, 
      search: search || undefined,
      ...filterValues 
    };

    api.get("/beneficiaries", { params })
       .then(r => setRows(r.data.data.content))
       .catch(() => toast.error("Failed to fetch records"))
       .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setRows([]);
    setHasSearched(false);
    setDynamicBlocks([]);
    
    if (type === "STUDENT") {
      setIsLoadingFilters(true);
      api.get("/beneficiaries/filters-schema", { params: { type: "STUDENT" } })
        .then(r => {
          const schemaWithoutBlock = (r.data.data.filters || []).filter(f => f.field !== "block");
          setDynamicSchema(schemaWithoutBlock);
          setFilterValues({});
        })
        .catch(() => {
          setDynamicSchema([]);
          setFilterValues({});
        })
        .finally(() => setIsLoadingFilters(false));
    } else {
      setDynamicSchema([]);
      setFilterValues({});
    }
  }, [type]);

  const handleDynamicFilterChange = (field, value) => {
    setFilterValues(prev => ({ ...prev, [field]: value }));

    if (field === "district") {
      setFilterValues(prev => ({ ...prev, block: "" }));
      setDynamicBlocks([]);

      if (value) {
        setIsLoadingBlocks(true);
        api.get("/beneficiaries/blocks", { params: { district: value } })
          .then(r => setDynamicBlocks(r.data.data || []))
          .catch(() => {
            toast.error("Failed to load blocks for this district");
            setDynamicBlocks([]);
          })
          .finally(() => setIsLoadingBlocks(false));
      }
    }
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setSelectedStudentId(null);
  };

  // ==========================================================================
  // 2. STUDENT DETAIL VIEW
  // ==========================================================================
  const handleStudentClick = (studentId) => {
    setSelectedStudentId(studentId);
    setIsLoadingDetails(true);
    api.get(`/beneficiaries/student-details/${studentId}`)
      .then(r => setStudentDetails(r.data.data))
      .catch(() => toast.error("Failed to load student details"))
      .finally(() => setIsLoadingDetails(false));
  };

  // ==========================================================================
  // 3. ADD / IMPORT LOGIC
  // ==========================================================================
  
  useEffect(() => {
    if (openAdd && nb.type === "STUDENT") {
      api.get("/beneficiaries/pending-imports")
         .then(r => {
           // FIX: Extract the 'content' array from the paginated object wrapper
           setPendingImports(r.data.data?.content || []);
           setSelectedImportIds([]);
           setImportSearch(""); // Reset search on open
         })
         .catch(() => toast.error("Failed to load pending students for import"));
    }
  }, [openAdd, nb.type]);

  // Derived state: Filter the pending imports based on the search bar
  const filteredPendingImports = pendingImports.filter(s => 
    (s.studentName || "").toLowerCase().includes(importSearch.toLowerCase()) || 
    (s.enrId || "").toString().includes(importSearch)
  );

  // Check if all currently visible (filtered) items are selected
  const isAllSelected = filteredPendingImports.length > 0 && 
                        filteredPendingImports.every(s => selectedImportIds.includes(s.studentId));

  const handleSelectAllImports = (e) => {
    if (e.target.checked) {
      // Add all currently filtered IDs to the selection
      const filteredIds = filteredPendingImports.map(s => s.studentId);
      const newSelection = Array.from(new Set([...selectedImportIds, ...filteredIds]));
      setSelectedImportIds(newSelection);
    } else {
      // Remove all currently filtered IDs from the selection
      const filteredIds = filteredPendingImports.map(s => s.studentId);
      const newSelection = selectedImportIds.filter(id => !filteredIds.includes(id));
      setSelectedImportIds(newSelection);
    }
  };

  const handleImportStudents = async () => {
    if (selectedImportIds.length === 0) return toast.error("Select at least one student");
    
    setIsImporting(true);
    try {
      await api.post("/beneficiaries/import", { studentIds: selectedImportIds });
      toast.success("Students successfully imported into DRMS!");
      setOpenAdd(false);
      setSelectedImportIds([]);
      if (type === "STUDENT") handleApplyFilters(); 
    } catch (err) {
      toast.error(err.response?.data?.message || "Import failed");
    } finally {
      setIsImporting(false);
    }
  };

  const handleSaveManual = async (e) => {
    e.preventDefault();
    try {
      await api.post("/beneficiaries", nb);
      toast.success("Beneficiary manually added");
      setOpenAdd(false); 
      setNb({ type: "SCHOOL", name: "", address: "", description: "" });
      handleApplyFilters();
    } catch (err) { 
      toast.error(err.response?.data?.message || "Failed to add beneficiary"); 
    }
  };

  // ==========================================================================
  // RENDER: STUDENT DETAIL VIEW
  // ==========================================================================
  if (selectedStudentId) {
    return (
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button variant="secondary" onClick={() => setSelectedStudentId(null)}>
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to List
          </Button>
          <h2 className="text-xl font-display font-bold text-emerald-950">Student Full Profile</h2>
        </div>

        {isLoadingDetails ? (
          <div className="p-8 text-center text-muted-foreground">Loading student profile...</div>
        ) : studentDetails ? (
          <div className="rounded-xl border border-emerald-900/10 bg-white p-6 space-y-6 shadow-sm">
            
            <div className="border-b pb-4">
              <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Personal Information</span>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Student Name</span>
                  <span className="text-lg font-semibold text-emerald-950">{studentDetails.studentName}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Enrollment ID (Code)</span>
                  <span className="mono font-semibold">{studentDetails.enrId}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Gender</span>
                  <span className="font-medium text-emerald-900">{studentDetails.gender || "—"}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Date of Birth</span>
                  <span className="font-medium text-emerald-900">{studentDetails.dob}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Contact Number</span>
                  <span className="font-medium text-emerald-900">{studentDetails.contactNumber}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Aadhaar Number</span>
                  <span className="font-medium text-emerald-900">{studentDetails.aadhaarNumber}</span>
                </div>
              </div>
            </div>

            <div className="border-b pb-4">
              <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Family & Background</span>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Father's Name</span>
                  <span className="font-medium text-emerald-900">{studentDetails.fatherName}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Mother's Name</span>
                  <span className="font-medium text-emerald-900">{studentDetails.motherName}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Disability Status</span>
                  <span className="font-medium text-emerald-900">{studentDetails.disabilityStatus}</span>
                </div>
                <div className="sm:col-span-2 lg:col-span-3">
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Home Address</span>
                  <span className="text-sm text-emerald-950">{studentDetails.homeAddress || "—"}</span>
                </div>
              </div>
            </div>

            <div>
              <span className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Academic Details</span>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-3">
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Cohort</span>
                  <span className="font-medium text-emerald-900">{studentDetails.cohortName || "—"}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Batch</span>
                  <span className="font-medium text-emerald-900">{studentDetails.batchName || "—"}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">Medium</span>
                  <span className="font-medium text-emerald-900">{studentDetails.medium || "—"}</span>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground uppercase tracking-wider block">School Name</span>
                  <span className="font-medium text-emerald-900">{studentDetails.schoolName}</span>
                </div>
              </div>
            </div>

          </div>
        ) : (
          <Empty title="Student details not found" />
        )}
      </div>
    );
  }

  // ==========================================================================
  // RENDER: MAIN LIST VIEW
  // ==========================================================================
  return (
    <div className="space-y-6">
      <Section title="Beneficiaries" kicker="People we serve"
        right={<Button onClick={() => setOpenAdd(v => !v)} data-testid="add-beneficiary-btn"><Plus className="w-4 h-4" /> Add beneficiary</Button>} />

      {/* --- ADD / IMPORT COMPONENT --- */}
      {openAdd && (
        <div className="rounded-xl border border-emerald-900/20 bg-emerald-50/30 p-6 mb-6 shadow-sm">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-emerald-950">Register Beneficiary in DRMS</h3>
            <p className="text-sm text-muted-foreground">Import active students from the portal or manually register schools/communities.</p>
          </div>

          <div className="mb-6 max-w-xs">
            <Select label="Beneficiary Category" value={nb.type} onChange={e => setNb({...nb, type: e.target.value})}>
              <option value="STUDENT">Student (Sync from Portal)</option>
              <option value="SCHOOL">School (Manual Entry)</option>
              <option value="COMMUNITY">Community (Manual Entry)</option>
            </Select>
          </div>

          {nb.type === "STUDENT" ? (
            <div className="space-y-4 max-w-2xl">
              
              {/* SEARCH BAR FOR PENDING STUDENTS */}
              <Input 
                placeholder="Search pending students by name or ID..." 
                value={importSearch} 
                onChange={e => setImportSearch(e.target.value)}
              />

              <div className="border border-emerald-900/10 rounded-lg bg-white overflow-hidden flex flex-col">
                
                {/* SELECT ALL HEADER */}
                <div className="bg-emerald-50/60 border-b border-emerald-900/10 p-3 flex items-center gap-3">
                  <input 
                    type="checkbox" 
                    checked={isAllSelected}
                    onChange={handleSelectAllImports}
                    disabled={filteredPendingImports.length === 0}
                    className="w-4 h-4 text-emerald-600 rounded border-gray-300 focus:ring-emerald-500 cursor-pointer"
                  />
                  <span className="text-sm font-semibold text-emerald-950">
                    Select All ({filteredPendingImports.length} visible)
                  </span>
                </div>

                {/* SCROLLABLE STUDENT LIST */}
                <div className="max-h-64 overflow-y-auto p-2">
                  {filteredPendingImports.length === 0 ? (
                    <div className="p-6 text-center text-sm text-muted-foreground">
                      {importSearch ? "No students match your search." : "No new active students available to import."}
                    </div>
                  ) : (
                    filteredPendingImports.map(s => (
                      <label key={s.studentId} className="flex items-center gap-3 p-2 hover:bg-emerald-50 rounded cursor-pointer transition-colors border-b border-emerald-50 last:border-0">
                        <input 
                          type="checkbox" 
                          className="w-4 h-4 text-emerald-600 rounded border-gray-300 focus:ring-emerald-500"
                          checked={selectedImportIds.includes(s.studentId)}
                          onChange={(e) => {
                            if(e.target.checked) setSelectedImportIds([...selectedImportIds, s.studentId]);
                            else setSelectedImportIds(selectedImportIds.filter(id => id !== s.studentId));
                          }} 
                        />
                        <div className="flex-1 text-sm font-medium text-emerald-950">{s.studentName}</div>
                        <div className="text-xs text-muted-foreground font-mono w-24 text-right">{s.enrId}</div>
                        <div className="text-xs text-emerald-700 w-24 text-right">{s.cohortName}</div>
                      </label>
                    ))
                  )}
                </div>
              </div>

              <Button onClick={handleImportStudents} disabled={selectedImportIds.length === 0 || isImporting}>
                <DownloadCloud className="w-4 h-4 mr-2" />
                {isImporting ? "Importing..." : `Import ${selectedImportIds.length} Selected Students`}
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSaveManual} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input label="Name" required value={nb.name} onChange={e => setNb(v => ({...v, name: e.target.value}))} />
              <Input label="Address / Location" value={nb.address} onChange={e => setNb(v => ({...v, address: e.target.value}))} />
              <div className="sm:col-span-2">
                <Input label="Description / Details" value={nb.description} onChange={e => setNb(v => ({...v, description: e.target.value}))} />
              </div>
              <div className="sm:col-span-2 pt-2">
                <Button type="submit">Save Manual Entry</Button>
              </div>
            </form>
          )}
        </div>
      )}

      {/* --- LIST & FILTERS --- */}
      <div className="rounded-xl border border-emerald-900/10 bg-white p-4 space-y-4">
        {/* Type & General Search Bar */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Select testid="ben-type-filter" value={type} onChange={handleTypeChange}>
            <option value="">Select Type to view…</option>
            <option value="STUDENT">Students</option>
            <option value="SCHOOL">Schools</option>
            <option value="COMMUNITY">Communities</option>
          </Select>
          <Input testid="ben-search" placeholder="Search by name…" value={search} onChange={e => setSearch(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleApplyFilters()} />
        </div>

        {/* Dynamic Filters Section with Cascading Blocks */}
        {dynamicSchema.length > 0 && (
          <div className="p-4 bg-emerald-50/50 border border-emerald-100 rounded-lg space-y-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-emerald-900">
              <Filter className="w-4 h-4" /> {isLoadingFilters ? "Loading Filters..." : "Filter Hierarchy (Optional Selection)"}
            </div>
            
            {!isLoadingFilters && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                {dynamicSchema.map(filter => {
                  if (filter.inputType === "select") {
                    return (
                      <Select 
                        key={filter.field} 
                        value={filterValues[filter.field] || ""} 
                        onChange={(e) => handleDynamicFilterChange(filter.field, e.target.value)}
                      >
                        <option value="">All {filter.label}s</option>
                        {filter.options?.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </Select>
                    );
                  }
                  return (
                    <Input 
                      key={filter.field} 
                      placeholder={filter.label} 
                      type={filter.inputType || "text"}
                      value={filterValues[filter.field] || ""} 
                      onChange={(e) => handleDynamicFilterChange(filter.field, e.target.value)} 
                    />
                  );
                })}

                {/* Dependent Block Dropdown */}
                <Select 
                  value={filterValues["block"] || ""} 
                  onChange={(e) => handleDynamicFilterChange("block", e.target.value)}
                  disabled={!filterValues["district"] || isLoadingBlocks}
                >
                  <option value="">{isLoadingBlocks ? "Loading blocks..." : "All Blocks"}</option>
                  {dynamicBlocks.map(block => (
                    <option key={block.value} value={block.value}>{block.label}</option>
                  ))}
                </Select>
              </div>
            )}
          </div>
        )}

        {/* Explicit Apply Filters Action Button */}
        {type && (
          <div className="flex justify-end pt-2">
            <Button onClick={handleApplyFilters} data-testid="apply-filters-btn" className="flex items-center gap-2">
              <Search className="w-4 h-4" /> {isLoading ? "Applying Filters..." : "Apply Filters & Fetch Data"}
            </Button>
          </div>
        )}

        {/* Results Grid with Student Name Hyperlink */}
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" style={{ opacity: isLoading ? 0.5 : 1 }}>
          {rows.map(b => (
            <div key={b.beneficiaryId} data-testid={`beneficiary-card-${b.beneficiaryId}`} className="rounded-xl border border-emerald-900/10 bg-[#F7F4EF]/60 p-4 flex flex-col">
              <div className="flex items-center justify-between">
                <div className="mono text-xs text-emerald-900">{b.code || b.enr_id}</div>
                <Badge tone={b.type === "STUDENT" ? "brand" : b.type === "SCHOOL" ? "indigo" : "warm"}>{b.type}</Badge>
              </div>
              
              {/* HYPERLINK ON STUDENT NAME */}
              <div className="mt-2">
                {b.type === "STUDENT" ? (
                  <button 
                    onClick={() => handleStudentClick(b.beneficiaryId)} 
                    className="font-display font-semibold text-emerald-950 hover:underline text-left flex items-center gap-1 group"
                  >
                    {b.name} <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </button>
                ) : (
                  <div className="font-display font-semibold text-emerald-950">{b.name}</div>
                )}
              </div>

              <div className="text-xs text-muted-foreground line-clamp-1">{b.address || "—"}</div>
              <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{b.description}</div>
              
              {b.medium && <div className="mt-auto pt-2 text-[10px] uppercase tracking-wider text-emerald-700/70 font-semibold">Medium: {b.medium}</div>}
            </div>
          ))}

          {!rows.length && !isLoading && hasSearched && (
            <div className="col-span-full">
              <Empty title="No beneficiaries match the selected filters" testid="beneficiaries-empty" />
            </div>
          )}

          {!rows.length && !isLoading && !hasSearched && type && (
            <div className="col-span-full py-8 text-center text-muted-foreground text-sm">
              Please select your filters above and click <strong>Apply Filters & Fetch Data</strong> to view results.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}